module.exports = __webpack_public_path__ + "img/FrontKingMountainBackground2_w_1297.dff44d6c.jpg";